module.exports = __webpack_public_path__ + "static/media/icon-email.f0f5b24a.svg";